import {
  Component,
  EventEmitter,
  Input,
  OnInit,
  Output,
  SimpleChanges,
} from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { ActivatedRoute } from '@angular/router';
import { select, Store } from '@ngrx/store';
import { TranslateService } from '@ngx-translate/core';
import dayjs from 'dayjs';
import { ToastrService } from 'ngx-toastr';
import { takeUntil } from 'rxjs';
import { ApiService } from 'src/app/services/api-services/api.service';
import { LangService } from 'src/app/services/lang.service';
import { updateAuth } from 'src/app/store/auth/auth.actions';
import {
  selectOrgSettings,
  selectOrgSettingsSuccess,
  selectUserDetails,
} from 'src/app/store/auth/auth.selector';
import { AutoUnsubscribeComponent } from 'src/app/utility/auto-unsubscribe.component';
import {
  isBenefitReceiptEnabled,
  showError,
} from 'src/app/utility/common-logic';
import { OrganizationSettings } from 'src/app/utility/model/organization';
import { UserProfile } from 'src/app/utility/model/user-profile';
import { environment } from 'src/environments/environment';
import { PointsInfoComponent } from '../points-info/points-info.component';
import { FinanceTransactionsPointSummaryLiteResponse } from 'src/app/utility/model/finance-transactions-point-summary-response';

@Component({
  selector: 'app-point',
  templateUrl: './point.component.html',
  styleUrls: ['./point.component.scss'],
})
export class PointComponent extends AutoUnsubscribeComponent implements OnInit {
  orgSettings: OrganizationSettings;
  userDetails: UserProfile;
  pointsAvailable: number;
  pointsAtTheStartOfYear: number;
  pointsEarned: number;
  pointsUsed: number;
  pointsExpiringThisMonth: number;
  msaPointsEarned: number;
  msaPointsUsed: number;
  flexDollarsEarned: number | null | undefined;
  flexDollarsRedeemed: number | null | undefined;
  msaPoints: number | null | undefined;
  @Input() loading = false;
  @Input() showMoreDetails = true;
  @Input() showMsaInTabView = false;
  @Input() year: any;
  @Input() pointType: string = 'fsa';
  @Input() liteTransactionDetails: FinanceTransactionsPointSummaryLiteResponse;
  @Output() toggleDrawer = new EventEmitter();
  @Output() reload = new EventEmitter();
  @Output() syncUserPoints = new EventEmitter();
  @Output() syncMsaPoints = new EventEmitter();
  @Output() update = new EventEmitter();
  showYearlyExpiringPoints =
    environment.settings.showPointsOnHome.showYearlyExpiringPoints;
  syncPoints = environment.settings.syncPoints;
  showPointsOnHome = environment.settings.showPointsOnHome;
  appName = environment.settings.app;
  showExpiryPoints: boolean = false;
  showMsaPoints: boolean = false;
  msaCreditLoading: boolean = false;

  constructor(
    private store: Store,
    public lang: LangService,
    private dialog: MatDialog,
    private route: ActivatedRoute,
    private api: ApiService,
    private toastr: ToastrService,
    private translate: TranslateService,
  ) {
    super();
  }

  ngOnInit() {
    this.loading = true;
    this.store
      .pipe(select(selectUserDetails), takeUntil(this.destroy$))
      .subscribe((user) => {
        this.userDetails = user;
      });
    this.store
      .pipe(select(selectOrgSettingsSuccess), takeUntil(this.destroy$))
      .subscribe((settingsLoaded) => {
        if (settingsLoaded) {
          this.store
            .pipe(select(selectOrgSettings), takeUntil(this.destroy$))
            .subscribe((settings) => {
              this.orgSettings = settings;
              // if (isBenefitReceiptEnabled(this.orgSettings)) {
              //   this.showMsaPoints = true;
              //   if (!this.showMsaInTabView && !this.msaCreditLoading) {
              //     this.getMsaCredit();
              //   }
              // }
            });
        }
      });
    this.getFsaPointSummary();
  }

  ngOnChanges(changes: SimpleChanges) {
    if (changes['year']) {
      this.getFsaPointSummary();
      // if (this.pointType === 'msa') {
      //   this.getMsaPointSummary();
      // } else {
      //   this.getFsaPointSummary();
      // }
    }
    if (changes['liteTransactionDetails']) {
      if (!!this.liteTransactionDetails) {
        this.pointsAvailable = this.liteTransactionDetails?.remaining_points;
        this.pointsAtTheStartOfYear =
          this.liteTransactionDetails?.points_at_year_start || 0;
        this.pointsEarned = this.liteTransactionDetails?.total_points;
        this.pointsUsed = this.liteTransactionDetails?.redeemed_points;
        this.pointsExpiringThisMonth =
          this.liteTransactionDetails?.points_expiring_this_month || 0;
      }
    }
  }

  getFsaPointSummary() {
    let params = '';
    if (this.year?.value) {
      params = `?year=${this.year?.value}`;
    }
    this.api
      .getPointsSummaryLite(params)
      .then((res) => {
        this.pointsAvailable = res?.remaining_points;
        this.pointsAtTheStartOfYear = res?.points_at_year_start || 0;
        this.pointsEarned = res?.total_points;
        this.pointsUsed = res?.redeemed_points;
        this.pointsExpiringThisMonth = res?.points_expiring_this_month || 0;
        const user_details_data = this.userDetails;
        this.store.dispatch(
          updateAuth({
            payload: {
              user_details: {
                ...user_details_data,
                real_time_points: res.remaining_points,
              },
            },
          }),
        );
      })
      .catch((err) => showError(err, this.toastr, this.translate))
      .finally(() => (this.loading = false));
  }

  // getMsaPointSummary() {
  //   let params = '';
  //   if (this.year?.value) {
  //     params = `?year=${this.year?.value}`;
  //   }
  //   this.api
  //     .getMsaPointsSummaryLite(params)
  //     .then((res) => {
  //       this.msaPoints = res?.remaining_points;
  //       this.msaPointsEarned = res?.total_points;
  //       this.msaPointsUsed = res?.redeemed_points;
  //     })
  //     .catch((err) => showError(err, this.toastr, this.translate))
  //     .finally(() => (this.loading = false));
  // }

  // getMsaCredit() {
  //   this.msaCreditLoading = true;
  //   this.loading = true;
  //   this.api
  //     .getBenefitCredit()
  //     .then((res) => {
  //       this.msaPoints = res['msa-credit'];
  //     })
  //     .catch((err) => showError(err, this.toastr, this.translate))
  //     .finally(() => {
  //       this.loading = false;
  //       this.msaCreditLoading = false;
  //     });
  // }

  get expiryPoint() {
    return (
      environment.settings.showPointsOnHome.showExpiringPoints ||
      !!Number(this.orgSettings?.points_expiry_frequency ?? 0)
    );
  }

  //This dialog is open only for yara.
  openPointCalculations() {
    const dialogRef = this.dialog.open(PointsInfoComponent, {
      maxWidth: '90vw',
    });
    dialogRef.afterClosed().subscribe(async (res) => {});
  }

  updateTransactions(pointType: string, category: string) {
    this.update.emit({
      point_category: category,
      point_type: pointType,
    });
  }

  get expiryPointsText() {
    const now = dayjs();
    let translationKey: string;
    let translateParams: any = {};

    if (this.showYearlyExpiringPoints) {
      translationKey = 'common.totalPointsExpiring';
      const endOfYear = now.endOf('year');
      translateParams['year'] = endOfYear.format('YYYY');
    } else {
      translationKey = 'common.pointsExpiringThisMonth';
      const endOfMonth = now.endOf('month');
      translateParams['date'] = endOfMonth.format('DD MMM');
    }

    return this.translate.instant(translationKey, translateParams);
  }
}
